export const ScriptStructuredData: React.FC<{ content: object }> = ({
  content,
}) => {
  if (!content) return;

  try {
    const objContent = content;

    if (objContent && typeof objContent === 'object') {
      return (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(objContent),
          }}
        ></script>
      );
    }
    return <></>;
  } catch (error) {
    console.error('JSON parse error:', (error as Error).message);
    return null;
  }
};
